import React, { useState } from 'react';

const Navigation: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header>
      <nav className="navbar">
        <div className="nav-container">
          <div className="logo" onClick={() => window.location.href = '/'} style={{ cursor: 'pointer' }}>
            <img src="/images/logo-nav.jpg?v=2" alt="World Conserve - Restaurando los bosques de Colombia" className="logo-img" />
            <span className="logo-text">World Conserve</span>
          </div>

          <ul className={`nav-menu ${isMobileMenuOpen ? 'active' : ''}`}>
            <li>
              <a href="/#contribute" className="nav-link">
                Plantar Árboles
              </a>
            </li>
            <li>
              <a href="/customer-portal" className="nav-link">
                Mis Árboles
              </a>
            </li>
          </ul>

          <div
            className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`}
            onClick={toggleMobileMenu}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Navigation;
